import Box from '@mui/material/Box'

type Props = {
  imagePath: string
  videoPath: string | null
}

function GameContainerBackground({ imagePath, videoPath }: Props) {
  return (
    <>
      <Box
        sx={{
          zIndex: -3,
          backgroundImage: `url(${process.env.PUBLIC_URL}/${imagePath})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        }}
      />
      {videoPath && (
        <video
          autoPlay
          muted
          loop
          id="video"
          src={`${process.env.PUBLIC_URL}/${videoPath}`}
          style={{
            zIndex: -2,
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            height: '100%',
            width: '100%',
            objectFit: 'cover',
          }}
        ></video>
      )}
      <Box
        sx={{
          zIndex: -1,
          background:
            'linear-gradient(to bottom, transparent, transparent 50%, black)',
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        }}
      />
    </>
  )
}

export default GameContainerBackground
